import { View, Text, FlatList, StyleSheet, RefreshControl } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { useNBAGames } from '@/hooks/useNBAGames';
import { MatchCard } from '@/components/MatchCard';
import { SectionHeader } from '@/components/SectionHeader';
import { EmptyState } from '@/components/EmptyState';
import { Colors, SportColors } from '@/constants/colors';

export default function NBAScreen() {
  const { liveGames, scheduledGames, finishedGames, loading, error, refresh, lastUpdated } = useNBAGames();
  const sport = SportColors.nba;

  return (
    <SafeAreaView style={styles.safe} edges={['top']}>
      <View style={styles.header}>
        <Text style={styles.title}>🏀 NBA</Text>
        {lastUpdated && (
          <Text style={styles.updated}>
            {lastUpdated.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit', second: '2-digit' })}
          </Text>
        )}
      </View>

      <FlatList
        data={[]}
        renderItem={null}
        ListHeaderComponent={
          <>
            {error && (
              <View style={styles.errorBanner}>
                <Text style={styles.errorText}>⚠️ {error}</Text>
              </View>
            )}

            {liveGames.length > 0 && (
              <>
                <SectionHeader title="Ao Vivo" count={liveGames.length} accent={Colors.live} />
                {liveGames.map((game) => <MatchCard key={game.id} game={game} />)}
              </>
            )}

            {scheduledGames.length > 0 && (
              <>
                <SectionHeader title="Hoje" count={scheduledGames.length} accent={sport.primary} />
                {scheduledGames.map((game) => <MatchCard key={game.id} game={game} />)}
              </>
            )}

            {finishedGames.length > 0 && (
              <>
                <SectionHeader title="Encerrados" count={finishedGames.length} />
                {finishedGames.map((game) => <MatchCard key={game.id} game={game} />)}
              </>
            )}

            {!loading && liveGames.length === 0 && scheduledGames.length === 0 && finishedGames.length === 0 && (
              <EmptyState
                icon="🏀"
                title="Sem jogos hoje"
                subtitle="A NBA tem jogos principalmente às terças, quartas, quintas e fins de semana"
              />
            )}
          </>
        }
        refreshControl={
          <RefreshControl refreshing={loading} onRefresh={refresh} tintColor={sport.primary} />
        }
        contentContainerStyle={styles.list}
      />
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  safe: { flex: 1, backgroundColor: Colors.background },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 16,
    paddingTop: 8,
    paddingBottom: 4,
  },
  title: { color: Colors.text, fontSize: 22, fontWeight: '800' },
  updated: { color: Colors.textMuted, fontSize: 11 },
  list: { paddingBottom: 24 },
  errorBanner: {
    margin: 16,
    padding: 12,
    backgroundColor: 'rgba(239,68,68,0.1)',
    borderRadius: 8,
    borderWidth: 1,
    borderColor: 'rgba(239,68,68,0.3)',
  },
  errorText: { color: '#fca5a5', fontSize: 13 },
});
